import { useNavigate } from "react-router";
import { galleryCategories } from "../data/galleryData";

const GalleryPage = () => {
    const navigate = useNavigate();

    const handleCategoryClick = (categoryId) => {
        navigate(`/gallery/${categoryId}`);
    };

    return (
        <div className="bg-primary min-h-screen">
            <section className="px-4 py-12 max-w-7xl mx-auto">
                <h2 className="text-4xl font-medium text-center text-red-800 mb-2">
                    PHOTO GALLERY
                </h2>
                <p className="text-lg text-center text-red-700 mb-2">
                    Moments in Leadership & Legacy
                </p>
                <p className="text-md text-center text-gray-800 mb-10">
                    Preserving the timeless heritage of Sanskrit through a
                    visual chronicle of leadership, culture, and education.
                </p>
                <div className="h-px w-full mb-10 bg-orange-700"></div>
                
                {/* Category Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {galleryCategories.map((category) => (
                        <div
                            key={category.id}
                            onClick={() => handleCategoryClick(category.id)}
                            className="group cursor-pointer bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                        >
                            {/* Category Image */}
                            <div className="relative h-64 overflow-hidden bg-gray-100">
                                <img
                                    src={category.thumbnail}
                                    alt={category.name}
                                    className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                                    loading="eager"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                                <div className="absolute bottom-0 left-0 right-0 p-4">
                                    <h3 className="text-2xl font-semibold text-white mb-1">
                                        {category.name}
                                    </h3>
                                    <p className="text-sm text-gray-200">
                                        {category.images.length} photos
                                    </p>
                                </div>
                            </div>
                            
                            {/* Category Description */}
                            <div className="p-4">
                                <p className="text-gray-700 text-sm">
                                    {category.description}
                                </p>
                                <div className="mt-4 flex items-center text-red-800 font-medium">
                                    <span>View Gallery</span>
                                    <svg className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default GalleryPage;
